import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

export type CancelCustomerAccountResponse = unknown;

export type CancelData = {
  cancel_reason: number;
  cancel_subreason: number[];
  free_text_response: string | null;
};

export async function postCancelCustomerAccount(data: CancelData) {
  // TODO: may need to add check to confirm cancel_reason exists
  return send<CancelCustomerAccountResponse>({
    path: '/api/cancel_customer_account/',
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: data,
  });
}
